<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="name"
                  label="Name"
                  v-model="categoryGroup.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="categoryGroup.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="categoryGroup.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="categoryGroup.id">
                <v-text-field
                  label="Created Date"
                  type="text"
                  v-model="createdDate"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="categoryGroup.id">
                <v-text-field
                  label="Created By"
                  type="text"
                  v-model="categoryGroup.createdBy"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="categoryGroup.id">
                <v-text-field
                  label="Updated Date"
                  type="text"
                  v-model="updatedDate"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="categoryGroup.id">
                <v-text-field
                  label="Updated By"
                  type="text"
                  v-model="categoryGroup.updatedBy"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="categoryGroup.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="showCategoryList()">
                    Add Category
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="categoryGroup.categoryGroupDetailList.length > 0"
                >
                  <v-flex xs4>Category Name</v-flex>
                  <v-flex xs1>Action</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(item, index) in categoryGroup.categoryGroupDetailList"
                  :key="index"
                >
                  <v-flex xs4>
                    <v-text-field
                      placeholder="Choose Category"
                      v-model="item.categoryName"
                      :rules="rules.nameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn icon @click="removeCategory(index, item.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Category list dialog -->
    <v-dialog v-model="showCategoryListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Category Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Category Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Category List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCategory"
              :headers="headers"
              :items="categoryList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    v-model="selectedCategory"
                  ></v-checkbox>
                </td>
                <td
                  @click="
                    setCategory(props.item, selectedIndex),
                      (showCategoryListDialog = !showCategoryListDialog)
                  "
                >
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.description }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds | format-ms-date-time
                  }}
                </td>
                <td>{{ props.item.updatedBy }}</td>
                <td>{{ props.item.status }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCategories">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { categoryGroupService } from "../../services/category-group-service";
import { CategoryGroup } from "../../models/model";
import { categoryService } from "../../services/category-service";
import { categoryGroupFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "CategoryGroupDetail",
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Category Group",
        disabled: false,
        to: "category-groups",
      },
      {
        text: "Category Group Detail",
        disabled: true,
      },
    ],
    categoryGroup: new CategoryGroup(),
    oldCategoryGroup: new CategoryGroup(),
    createdDate: "",
    updatedDate: "",
    statusFlag: true,
    categoryList: [],
    showListLoading: false,
    queryParams: {
      name: "",
      code: "",
      status: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    totalRows: 0,
    rules: new categoryGroupFormRules(),
    showCategoryListDialog: false,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" },
    ],
    selectedCategory: [],
    headers: [
      { text: "Code", align: "left", value: "name" },
      { text: "Name", value: "code" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
    ],
    rowsPerPageItems: [10, 50, 100],
    saveLoading: false,
    responseError: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getCategoryList();
      },
      deep: true,
    },
  },
  created() {
    const id = this.$route.params.id;
    if (id != "new") {
      this.getCategoryGroupDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.categoryGroup.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        categoryGroupService
          .saveCategoryGroup(this.categoryGroup)
          .then((res) => {
            if (res) {
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    goBack() {
      this.$router.push("/category-groups");
    },
    getCategoryGroupDetail(id) {
      categoryGroupService
        .getCategoryGroupDetail(id)
        .then((res) => {
          this.categoryGroup = res.data;
          this.createdDate = commonService.formatDate(
            new Date(this.categoryGroup.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.categoryGroup.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );

          // deep copy
          this.oldCategoryGroup = JSON.parse(JSON.stringify(res.data));

          this.statusFlag =
            this.categoryGroup.status == "ACTIVE" ? true : false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoryList() {
      var this_ = this;
      this_.showListLoading = true;
      this_.categoryList = [];
      return categoryService
        .getCategoryWithoutGroup(
          this_.queryParams,
          this_.pagination.page,
          this_.pagination.rowsPerPage
        )
        .then((res) => {
          if (res.data) {
            this_.categoryList = res.data.categoryList;
            this_.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this_.showListLoading = false;
        });
    },
    showCategoryList() {
      // Clean query params
      this.queryParams.name = "";
      this.queryParams.code = "";
      this.queryParams.status = "";

      this.getCategoryList().then(
        (this.showCategoryListDialog = !this.showCategoryListDialog)
      );
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getCategoryList();
    },
    toggleAll() {
      if (this.selectedCategory.length) this.selectedCategory = [];
      else {
        this.selectedCategory = this.categoryList.slice();
      }
    },
    setCategory(category, index) {
      this.categoryGroup.categoryGroupDetailList[index].categoryId =
        category.id;
      this.categoryGroup.categoryGroupDetailList[index].categoryName =
        category.name;
    },
    setCategories() {
      if (this.selectedCategory.length) {
        this.selectedCategory.forEach((item) => {
          let categoryGroupDetail = {
            id: "",
            categoryId: "",
            categoryName: "",
          };
          categoryGroupDetail.categoryId = item.id;
          categoryGroupDetail.categoryName = item.name;
          this.categoryGroup.categoryGroupDetailList.push(categoryGroupDetail);
        });
      }
      this.showCategoryListDialog = !this.showCategoryListDialog;
    },
    removeCategory(index, categoryGroupId) {
      if (categoryGroupId) {
        // add deleted wayCustomerShop id
        if (!this.categoryGroup.deleteCategoryGroupDetailIds) {
          this.categoryGroup.deleteCategoryGroupDetailIds = [];
        }
        this.categoryGroup.deleteCategoryGroupDetailIds.push(categoryGroupId);
      }
      this.$delete(this.categoryGroup.categoryGroupDetailList, index);
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.categoryGroup.id) {
        this.categoryGroup = new CategoryGroup();
        this.statusFlag = true;
      } else {
        this.categoryGroup = JSON.parse(JSON.stringify(this.oldCategoryGroup));
        this.statusFlag = this.way.status == "ACTIVE" ? true : false;
      }
    },
  },
};
</script>